export default __webpack_public_path__ + "static/ms-icon-144x144-308c26f8ab5094547513cc1dabdbab56.png";